import ControlPointIcon from '@mui/icons-material/ControlPoint';
import EditIcon from '@mui/icons-material/Edit';
import { Box, Chip, Menu, MenuItem, Button } from '@mui/material';
import * as React from 'react';
import { useState } from 'react';
import { useGetList } from 'react-admin';
import { TagsSearchInput } from './TagsSearchInput';
import { Tag } from '@wwf/sdk';

export const TagSearchButtonWithModal = ({
    openTagCreateDialog,
    selectedTags,
    onTagAdd,
}: {
    openTagCreateDialog: () => void;
    selectedTags: Tag['id'][];
    onTagAdd: (id: Tag['id']) => void;
}) => {
    const [tagsPerPage, setTagsPerPage] = useState(10);
    const anchorEl = React.useRef<HTMLDivElement>(null);
    const [listOpen, setListOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');

    const handleMenuOpen = () => {
        setListOpen(true);
    };

    const handleMenuClose = () => {
        setSearchQuery('');
        setTagsPerPage(10);
        setListOpen(false);
    };

    const handleTagAdd = (id: Tag['id']) => {
        onTagAdd(id);
        setListOpen(false);
    };

    const { data: allTags, total } = useGetList<Tag>('tags', {
        pagination: { page: 0, perPage: tagsPerPage },
        sort: { field: 'name', order: 'ASC' },
        filter: searchQuery ? { name: { like: `%${searchQuery}%` } } : {},
    });
    const unselectedTags =
        allTags && allTags.filter(tag => !selectedTags.includes(tag.id));

    return (
        <>
            <Box mt={1} ref={anchorEl}>
                <Chip
                    icon={<ControlPointIcon />}
                    size="small"
                    variant="outlined"
                    onClick={handleMenuOpen}
                    label="Add tag"
                    color="primary"
                />
            </Box>
            <Menu
                open={listOpen}
                onClose={handleMenuClose}
                anchorEl={anchorEl.current}
                slotProps={{
                    paper: {
                        sx: {
                            minWidth: 250,
                            maxHeight: 400,
                        },
                    },
                }}
            >
                <TagsSearchInput setSearchQuery={setSearchQuery} />

                {unselectedTags?.map((tag, index) => (
                    <MenuItem key={index} onClick={() => handleTagAdd(tag.id)}>
                        <Chip
                            size="small"
                            variant="outlined"
                            label={tag.name}
                            style={{
                                backgroundColor: tag.color || undefined,
                                border: 0,
                            }}
                            onClick={() => handleTagAdd(tag.id)}
                        />
                    </MenuItem>
                ))}
                <MenuItem onClick={openTagCreateDialog}>
                    <Chip
                        icon={<EditIcon />}
                        size="small"
                        variant="outlined"
                        onClick={openTagCreateDialog}
                        color="primary"
                        label="Create new tag"
                    />
                </MenuItem>
                {total && total > tagsPerPage && (
                    <MenuItem onClick={() => setTagsPerPage(tagsPerPage + 10)}>
                        <Button
                            size="small"
                            variant="text"
                            fullWidth
                            sx={{ justifyContent: 'flex-start' }}
                        >
                            Load more tags
                        </Button>
                    </MenuItem>
                )}
            </Menu>
        </>
    );
};
